import gql from 'graphql-tag';
import { evaluationFieldsFragment } from './evaluationFieldsFragment';
import { questionFieldsFragment } from './questionFieldsFragment';

export const scheduledSessionParticipantEntryProgressFieldsFragment = gql`
  fragment AdminScheduledSessionParticipantEntryProgressFields on ScheduledSessionParticipantEntryProgress {
    type
    evaluation {
      _ref
    }
    question {
      _ref
    }
    timestamp
    # sectionStart and sectionEnd are legacy fields kept for backward compatibility.
    # The new source of truth for tracking durations is the linear sequence of events
    # inside the root 'sessionProgress' array, filtering by 'type' (e.g., 'sectionStart')
    # and reading its 'timeStamp'.
    sectionStart
    sectionEnd
    rQuestion {
      ...AdminQuestionFields
    }
    rEvaluation {
      ...AdminEvaluationFields
    }
  }

  ${questionFieldsFragment}
  ${evaluationFieldsFragment}
`;
